import getOrganizationDetailTabPath from '@/pages/admin/organizations/OrganizationDetail/helpers/getOrganizationDetailTabPath';
import type { GetLiveInstanceSectionPathParams } from '../types';

const getLiveInstanceSectionPath = ({
    organizationId,
    instanceId,
    section,
}: GetLiveInstanceSectionPathParams): string =>
    `${getOrganizationDetailTabPath({
        organizationId,
        tab: 'services',
        search: '',
    })}/${instanceId}/${section}`;

export default getLiveInstanceSectionPath;
